import React, { Component } from "react";
import { Grid } from "semantic-ui-react";
import { withTranslation } from "react-i18next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog } from "@fortawesome/pro-regular-svg-icons";

import { ConditionIcon, GalleryButton, Expandable } from "../../../../../components";
import { Responsive, DesktopOnly, MobileOnly } from "../../../../../layout";
import { round2, getItemName, getImageAndVideoFileTypes, getInterventionPriceWithVAT } from "../../../../../util/common";
import { getTyreSeasonIcon, TYRE_POSITION } from "../../../../../util/tyre";

import "./index.scss";

class FixedItems extends Component {
  renderIntervention = (item, id, description, price, status, profile) => {
    let rep = null;
    if (item.tyre_position > 0 && item.tyre_replacements.length > 0) rep = item.tyre_replacements.find(r => r.mechanic_fixed);

    const { images, videos } = getImageAndVideoFileTypes(item.attachments);

    return (
      <Grid.Row key={id} className="fixed-row">
        <Grid.Column computer={5} widescreen={6} mobile={16}>
          <div className="interventions-row-title">
            <ConditionIcon status={status} className="fixed-status-icon" />

            <Expandable className="fixed-title" text={getItemName(this.props.t, item)} />
          </div>
        </Grid.Column>

        <DesktopOnly>
          <Grid.Column computer={5} widescreen={6} mobile={16} className="fixed-description">
            {profile && <Expandable text={profile + "mm"} />}

            <Expandable text={description} />
          </Grid.Column>
        </DesktopOnly>

        {(profile || description) && (
          <MobileOnly>
            {profile && <Expandable text={profile + "mm"} />}

            <Expandable text={description} />
          </MobileOnly>
        )}

        {price && (
          <MobileOnly>
            <Grid.Column width={16}></Grid.Column>
            <Grid.Column width={6}>{price}</Grid.Column>
          </MobileOnly>
        )}

        <DesktopOnly>
          <Grid.Column width={3} className="interventions-price">
            {price}
          </Grid.Column>
          {rep && (
            <>
              <Grid.Column width={5} className="fixed-replaced">
                {this.props.t("cc_replaced_with").message || "Replaced with"}: {getTyreSeasonIcon(rep.tyre.season)}
                {rep.tyre.manufacturer}
                <div>{rep.tyre.description}</div>
              </Grid.Column>
              <Grid.Column width={5} className="fixed-description">
                <Expandable text={rep.remarks} />
              </Grid.Column>
            </>
          )}
        </DesktopOnly>
        <Grid.Column computer={1} mobile={3}>
          <GalleryButton images={images} videos={videos} />
        </Grid.Column>
      </Grid.Row>
    );
  };

  renderInterventionPrice = intervention => {
    const { include_vat } = this.props.settings;

    if (!(intervention.price > 0.01)) return null;

    const price = include_vat ? getInterventionPriceWithVAT(intervention, this.props.settings) : intervention.price;

    return <span className="fixed-price">€ {round2(price).toFixed(2)}</span>;
  };

  renderFixedItems = interventions => {
    if (!Array.isArray(interventions)) return null;

    return interventions.map(i => this.renderIntervention(i, i.id, i.description, this.renderInterventionPrice(i), i.question_result_status));
  };

  render() {
    let { fixedItems, showMobile, t } = this.props;

    if (fixedItems.length < 1) return null;

    return (
      <Responsive showMobile={showMobile}>
        <Grid verticalAlign="middle" className="repair-overview-v2 fixed-container component-container">
          <Grid.Row className="fixed-heading">
            <Grid.Column width={16}>
              <FontAwesomeIcon icon={faCog} className="fixed-heading-icon" />
              <h4 className="fixed-heading-title">{t("cc_items_fixed").message || "Items fixed"}</h4>
            </Grid.Column>
          </Grid.Row>
          {this.renderFixedItems(fixedItems)}
        </Grid>
      </Responsive>
    );
  }
}

const TranslatedFixedItems = withTranslation()(FixedItems);

TranslatedFixedItems.filterFixedItems = results =>
  results.filter(r => {
    if (TYRE_POSITION.IS_TYRE(r.tyre_position)) {
      if (r.tyre_replacements.length > 0) {
        let rep = r.tyre_replacements.find(tr => tr.mechanic_fixed);
        if (!rep) return false;

        r.price = rep.price;
        return true;
      }
    }

    return r.mechanic_fixed;
  });

export default TranslatedFixedItems;
